export function fmtArea(km2: number): string {
  if (km2 >= 1_000) return `${(km2 / 1_000).toFixed(2)} mil km²`;
  return `${km2.toFixed(1)} km²`;
}

export function fmtPower(gw: number): string {
  if (gw >= 1_000) return `${(gw / 1_000).toFixed(2)} TW`;
  if (gw >= 1) return `${gw.toFixed(2)} GW`;
  return `${(gw * 1_000).toFixed(1)} MW`;
}

export function fmtEnergy(gwh: number): string {
  if (gwh >= 1_000_000) return `${(gwh / 1_000_000).toFixed(2)} PWh`;
  if (gwh >= 1_000) return `${(gwh / 1_000).toFixed(2)} TWh`;
  if (gwh >= 1) return `${gwh.toFixed(1)} GWh`;
  return `${(gwh * 1_000).toFixed(0)} MWh`;
}

export function fmtCurrency(value: number): string {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    maximumFractionDigits: 0,
  });
}

export const OPERATOR_LABELS: Record<string, string> = {
  menor: "Menor que",
  maior: "Maior que",
  entre: "Entre",
};

export const ENERGY_TYPE_LABELS: Record<string, string> = {
  eolica: "Eólica",
  solar: "Solar",
};
